import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-formcontrol-array',
  template: require('./formcontrol-array.component.html'),
  styles: [require('./formcontrol-array.component.scss')],
})
export class FormcontrolArrayComponent {
  @Input() form: FormGroup;
  @Input() field: string;
  @Input() displayName: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/formcontrol-array/formcontrol-array.component.ts